import { ref, watch, type Ref } from 'vue'

let onUnauthenticated: (() => void) | null = null
let on401Detector: (err: unknown) => boolean = () => false

export function configureAsyncData(opts: { onUnauthenticated: () => void; is401: (err: unknown) => boolean }) {
    onUnauthenticated = opts.onUnauthenticated
    on401Detector = opts.is401
}

export interface UseAsyncDataOptions {
    immediate?: boolean
    watch?: Ref<unknown>[]
}

export function useAsyncData<T>(fetcher: () => Promise<T>, options: UseAsyncDataOptions = {}) {
    const data = ref<T | null>(null) as Ref<T | null>
    const loading = ref(false)
    const error = ref<unknown>(null)

    async function refetch() {
        loading.value = true
        error.value = null
        try {
            data.value = await fetcher()
        } catch (e) {
            error.value = e
            if (on401Detector(e) && onUnauthenticated) {
                onUnauthenticated()
            }
        } finally {
            loading.value = false
        }
    }

    if (options.immediate !== false) {
        refetch()
    }

    if (options.watch?.length) {
        watch(options.watch, () => refetch(), { deep: true })
    }

    return { data, loading, error, refetch }
}
